import { useSeo } from "@/lib/site";
import { Logo, LogoSymbol, Wordmark } from "@/components/brand/Logo";

const COLOURS = [["Warm cream", "#F7F2EA", "text-ink"], ["Soft sage", "#A7B8A0", "text-ink"], ["Muted teal", "#2F6B6A", "text-cream"], ["Clay", "#C86D51", "text-white"], ["Deep charcoal", "#24282B", "text-cream"]];

export default function Brand() {
  useSeo("Brand", "The Addiction & Us brand identity.");
  return (
    <div className="container-site pt-14 md:pt-20" data-testid="brand-page">
      <p className="eyebrow mb-4">Brand identity · concept</p>
      <h1 className="text-4xl sm:text-5xl">The ampersand at the heart of it.</h1>
      <p className="mt-5 text-lg text-ink-soft max-w-2xl">The “&amp;” joins two things that belong together. For us, it stands for connection: the person experiencing addiction and the people standing alongside them. The sage dot represents someone being noticed.</p>
      <div className="mt-12 grid gap-5 lg:grid-cols-3">
        <div className="card-soft p-10 flex items-center justify-center min-h-[220px]"><Logo /></div>
        <div className="rounded-3xl bg-[#1E2326] p-10 flex items-center justify-center min-h-[220px]"><Logo tone="light" /></div>
        <div className="card-soft p-10 flex items-end justify-center gap-6 min-h-[220px]"><LogoSymbol size={96} /><LogoSymbol size={56} /><LogoSymbol size={32} /></div>
      </div>
      <div className="mt-5 card-soft p-10 flex justify-center"><Wordmark className="!text-5xl sm:!text-6xl" /></div>
      <h2 className="mt-16 text-3xl">Colour</h2>
      <ul className="mt-6 grid gap-4 grid-cols-2 md:grid-cols-5">
        {COLOURS.map(([n, hex, t]) => <li key={hex} className={`rounded-3xl p-6 h-36 flex flex-col justify-end border border-ink/5 ${t}`} style={{ background: hex }}><span className="font-semibold">{n}</span><span className="text-sm opacity-80">{hex}</span></li>)}
      </ul>
      <h2 className="mt-16 text-3xl">Typography</h2>
      <div className="mt-6 grid gap-5 md:grid-cols-2">
        <div className="card-soft p-8"><p className="font-serif text-5xl">Fraunces</p><p className="mt-2 text-ink-soft">Headings: warm, editorial and human.</p></div>
        <div className="card-soft p-8"><p className="font-sans text-5xl font-semibold">Figtree</p><p className="mt-2 text-ink-soft">Body text: clear and highly legible.</p></div>
      </div>
      <p className="mt-10 text-sm text-ink-muted">Concept artwork. Before print production, a designer should create final outlined vector files.</p>
    </div>
  );
}
